// extracted by mini-css-extract-plugin
module.exports = {"modal":"styles_modal__IRaL9","modal-content":"styles_modal-content__EsXSI","modal-body":"styles_modal-body__2Juck","modal-footer":"styles_modal-footer__esN3p"};